import React from 'react';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-100 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-invert">
          <p className="text-gray-300">Last updated: {new Date().toLocaleDateString()}</p>
          
          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">1. Introduction</h2>
            <p className="text-gray-300">
              This Privacy Policy describes how we collect, use, and handle your personal information
              when you use our services. We take your privacy seriously and are committed to protecting
              your personal information.
            </p>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">2. Information We Collect</h2>
            <p className="text-gray-300">We collect information that you provide directly to us:</p>
            <ul className="list-disc pl-6 mt-2 text-gray-300">
              <li>Account information (name, email, password)</li>
              <li>Profile information</li>
              <li>Content you create, upload, or share</li>
              <li>Communications with us</li>
            </ul>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">3. How We Use Your Information</h2>
            <p className="text-gray-300">We use the information we collect to:</p>
            <ul className="list-disc pl-6 mt-2 text-gray-300">
              <li>Provide, maintain, and improve our services</li>
              <li>Process your transactions</li>
              <li>Send you technical notices and support messages</li>
              <li>Communicate with you about products, services, and events</li>
            </ul>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">4. Data Security</h2>
            <p className="text-gray-300">
              We implement appropriate technical and organizational measures to protect your personal
              information against unauthorized or unlawful processing, accidental loss, destruction,
              or damage.
            </p>
          </section>

          <section className="mt-8">
            <h2 className="text-2xl font-semibold text-gray-100 mb-4">5. Contact Us</h2>
            <p className="text-gray-300">
              If you have any questions about this Privacy Policy, please contact us at:
              trycreatorform@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}; 